import { Grid, Skeleton, Box } from "@mui/material";
import CardActions from "src/pages/sistema/components/CardActions";
import { FieldView, SectionBox } from "src/pages/sistema/components/FieldView";
import { OperacionNOTESParametroFields } from '../types/fields';
import { useNOTESParametros } from '../hooks/useNOTESParametros';

type SeccionNOTESOtrosParametrosProps = {
  idOperacion: number;
}

const SeccionNOTESOtrosParametros = ({ idOperacion }: SeccionNOTESOtrosParametrosProps) => {
  const { parametros, isLoading, isError } = useNOTESParametros(idOperacion);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <Skeleton variant='rectangular' height={200} />
      </Box>
    );
  }

  if (isError || !parametros || parametros.length === 0) {
    return <></>;
  }

  return (
    <CardActions title='Sección otros parámetros de la nota estructurada' icon='mdi:tune' colapsable>
      <SectionBox>
        {parametros
          .sort((a, b) => (a[OperacionNOTESParametroFields.Orden] ?? 0) - (b[OperacionNOTESParametroFields.Orden] ?? 0))
          .map((param) => (
            <Grid item xs={12} md={6} key={param.id}>
              <FieldView
                label={param[OperacionNOTESParametroFields.Titulo]}
                value={param[OperacionNOTESParametroFields.Valor]}
              />
            </Grid>
          ))}
      </SectionBox>
    </CardActions>
  );
}

export default SeccionNOTESOtrosParametros;
